import {useMutation} from "@apollo/client";
import {Slot} from "@App/types";
import {UNBLOCK_SLOT, UnblockSlotQuery} from "@App/graphql/mutations/unblockSlot";
import {useDispatch} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {actionCreators} from '@App/state'

export const useUnblockSlot = () => {

    const [unblock, {loading, data, error}] = useMutation<UnblockSlotQuery>(UNBLOCK_SLOT)
    // redux action creators
    const dispatch = useDispatch();
    const {chooseSlot} = bindActionCreators(actionCreators, dispatch)

    const unblockSlot = (slot: Slot) => {
        unblock({
            variables: {
                slot: slot.id,
                calendar: slot.calendar_id,
            }
        })
        // reset id
        slot.id = null
        chooseSlot(slot)
    }

    return {
        error,
        loading,
        unblockSlot,
        successful: data ? data.unblock : null,
    }
}
